<template>
	<div
		class="CategoriesContent"
		:class="{
			'CategoriesContent--dark': client.name === 'Dolci',
			'CategoriesContent--light': client.name !== 'Dolci',
		}"
	>
		<div
			v-for="(item, index) in list"
			:key="index"
		>
			<h3 class="CategoriesContent__title">{{ getTranslation(item.categories[0].name) }}</h3>

				<ProductsList
					:list="item.items"
					:selectProduct="selectProduct"
				/>
		</div>
	</div>
</template>

<script>
import ProductsList from './ProductsList.vue'

export default {
	props: [
		'list',
		'selectProduct',
	],

	components: {
		ProductsList,
	},
}
</script>

<style lang="scss" scoped>
	.CategoriesContent {
		&__title {
			font-size: 24px;
			padding: 54px 0 12px;
			margin: 0;

			@media (min-width: 768px) {
				text-align: center;
				font-size: 28px;
			}
		}

		&--light {
			.CategoriesContent__title {
				color: #24242E;
			}
		}

		&--dark {
			.CategoriesContent__title {
				color: white;
				font-family: 'Harrys-Regular', sans-serif;
			}
		}
	}
</style>
